import angular from 'angular'
import routers from './routers.js'
import accountSubjectCtrl from './accountSubjectCtrl.js'

export default angular
    .module('declaration.baseSetting.accountSubject', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('accountSubjectCtrl', accountSubjectCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/baseSetting/accountSubject/index.js